// extracted by mini-css-extract-plugin
module.exports = {"orderItem":"U+qTr","orderItem-info":"_00PFH","title":"NOoPt","desc":"VLt4o","orderItem-info-actions":"Iv9n-","orderItem-info-actions-button":"amdT4","orderItem-image":"hkmW2"};